import React from 'react';
import css from './BroPlan.module.scss';
import CheckBox from './CheckBox';
import {Section} from '../section/Section';
import {SETUP_STEP_TYPES} from '../../../setupSteps/SetupStepTypes';

export const BroPlanSection: React.FC<{type: SETUP_STEP_TYPES}> = ({type}) => {
  return (
    <Section type={type}>
      <div className={css.section_pricing}>
        <div
          className={`${css.section_pricing_plan} ${css.section_pricing_bottom_border}`}
        >
          <div>
            <div className={css.plan_name}>
              Annual{' '}
              <span className={css.plan_description}>
                · <s>$59.88</s> $44.99 billed yearly
              </span>
              <span className={css.plan_badge}>-25% OFF</span>
            </div>
            <div className={css.price}>
              $3.75 <span className={css.price_is_monthly_text}> / mo</span>
            </div>
          </div>
          <a
            href="https://pulsoid.net/pricing?bi.from=setup&pricing_plan=yearly"
            className={css.upgrade_button}
            target="_blank"
          >
            Upgrade
          </a>
        </div>
        <div
          className={`${css.section_pricing_plan} ${css.section_pricing_bottom_border}`}
        >
          <div>
            <div className={css.plan_name}>
              Monthly{' '}
              <span className={css.plan_description}>· Billed every month</span>
            </div>
            <div className={css.price}>
              $4.99 <span className={css.price_is_monthly_text}> / mo</span>
            </div>
          </div>
          <a
            href="https://pulsoid.net/pricing?bi.from=setup&pricing_plan=monthly"
            className={css.upgrade_button}
            target="_blank"
          >
            Upgrade
          </a>
        </div>
        <div className={css.section_pricing_plan}>
          <div>
            <div className={css.plan_name}>
              Lifetime{' '}
              <span className={css.plan_description}>· One-time payment</span>
              <span className={css.plan_badge}>Best Value</span>
            </div>
            <div className={css.price}>$135</div>
          </div>
          <a
            href="https://pulsoid.net/pricing?bi.from=setup&pricing_plan=lifetime"
            className={css.upgrade_button}
            target="_blank"
          >
            Upgrade
          </a>
        </div>
      </div>
      <div className={css.section_bro_features}>
        <div className={css.section_bro_title}>
          <span className={css.bro_text}>BRO </span>ADVANCED HEART RATE WIDGETS
        </div>
        <ul className={css.section_bro_features_list}>
          <li>
            <CheckBox />
            <span>Real-time graph widget</span>
          </li>
          <li>
            <CheckBox />
            <span>Game-styled widgets</span>
          </li>
          <li>
            <CheckBox />
            <span>Animated text widgets</span>
          </li>
          <li>
            <CheckBox />
            <span>Fitness Widgets (zones, calories)</span>
          </li>
        </ul>
      </div>
      <div className={css.section_bro_features}>
        <div className={css.section_bro_title}>
          <span className={css.bro_text}>BRO </span>API AND INTEGRATIONS
        </div>
        <ul className={css.section_bro_features_list}>
          <li>
            <CheckBox />
            <span>Community dev plugins for VRChat, Vtube, and more</span>
          </li>
          <li>
            <CheckBox />
            <span>
              Discord, Lumistream, Voicemod, Steamdeck, and MixItUp integrations
            </span>
          </li>
          <li>
            <CheckBox />
            <span>API for unlimited capabilities</span>
          </li>
        </ul>
      </div>
      <div className={css.section_bro_features}>
        <div className={css.section_bro_title}>
          <span className={css.bro_text}>BRO </span>CUSTOMIZATIONS
        </div>
        <ul className={css.section_bro_features_list}>
          <li>
            <CheckBox />
            <span>Upload your own pictures, fonts, videos</span>
          </li>
          <li>
            <CheckBox />
            <span>20+ settings to match your style</span>
          </li>
          <li>
            <CheckBox />
            <span>Animations, ranges, alerts, and more</span>
          </li>
        </ul>
      </div>
      <div className={css.section_bro_features}>
        <div className={css.section_bro_title}>
          <span className={css.bro_text}>BRO </span>SUPPORT
        </div>
        <ul className={css.section_bro_features_list}>
          <li>
            <CheckBox />
            <span>Your payments fuel ongoing development and upgrades</span>
          </li>
        </ul>
      </div>
    </Section>
  );
};
